/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */

;(function($) {

  // Enable ALL jquery plugins here
  
  // enable select2
  $(document).ready(function () {
    $('.select2').each(function() {
      // select2
      var select2 = $(this).select2({
        dir: "rtl",
        allowClear: false,
        language: "he",
        //placeholder: '', ??
        minimumResultsForSearch: 0,
        width: '100%',
        // maximumSelectionLength: 10,
        containerCssClass: 'select2-box-theme',
        dropdownCssClass:  'select2-box-theme'
      }).css("max-height","400px");

      // add focus events
      // select2.next(".select2").find(".select2-selection").focus(function() {
      //   select2.select2("open");
      // });

      // add scroll bar
      var scrollContent;
      select2.on('select2:open', function () {

        if(scrollContent) {
          return true;
        }

        // show scroll bar
        scrollContent = $('.select2-container--open .select2-results>ul').niceScroll({
          autohidemode: false,
          cursorcolor: '#565656',
          cursorwidth: 5,
          rtlmode: true,
          railalign:'left',
          cursorborder: '1px solid #e6e6e6',
          // rtlmode:true,
          hwacceleration:false,
          cursorminheight: 54
        });
      });
    });
  });

  // enable qtip2
  $(document).ready(function () {

    /**
     * Get get value from element data attribute.
     *
     * @param {String} name
     * @param {String} [defaultTitle]
     */
    var getQtipData = function(name, defaultTitle) {
      defaultTitle = defaultTitle || null;
      var title    = this.data(name);

      if (typeof title === typeof undefined || title === false) {
        return defaultTitle;
      }

      return title;
    };

    /**
     * Get validation text.
     */
    var getQtipValidationText = function() {
      var list    = this.getValidationRulesList();
      var valName = getQtipData.call(this, 'qtip2-validation-name');
      var html    = '';

      // generate html for ul li element
      var generateLIHtml = function (rule, message) {
        var html     = '';
        var template = '<li data-rule="{0}">{1}</li>';

        // if rule has more than one messages
        if(Array.isArray(message)) {
          for(var k in message) {
            html += template.format(rule, message[k])
          }
        } else {
          html = template.format(rule, message);
        }

        return html;
      };

      // if no validation rules added for element
      if(0 === Object.keys(list).length) {
        return false;
      }

      // generate html for ul element
      html = '<ul class="qtip2-validation-content">';

      // default messages (not from rules). Can be separated by |||
      if(valName) {
        var vna = valName.split('|||');

        for(var n in vna) {
          html += generateLIHtml('rule-default', vna[n]);
        }
      }

      // all rules messages
      $.each(list, function (rule, message) {
        if(false == message || '' == message) {
          return true;
        }

        html += generateLIHtml(rule, message);
      });

      return html + '</ul>';
    };

    // form validation qtip
    $('.validation input:not(.validation-disable-qtip), .validation select:not(.validation-disable-qtip)').each(function() {
      var el       = $(this);
      var title    = getQtipData.call(el, 'qtip2-title', $.translate('This Field Must Contain:'));
      var adjustX  = getQtipData.call(el, 'qtip2-x', -51);
      var text     = getQtipValidationText.call(el);

      el.qtip({
        content: {
          text: text,
          title: function () { return title }
        },
        hide: {
          event: 'blur select2:close'
        },
        show: {
          event: 'focus select2:open'
        },
        style: {
          classes: 'qtip-box-form-validation qtip-bootstrap',
          tip: false
        },
        position: {
          my: 'top right',
          at: 'top left',
          adjust: {
            x: adjustX
          }
        }
      });

      if(el.hasClass('has-predefined-value')) {
        el.qtip('disable');
      }

      // fix for checkboxes
      if('checkbox' == el.attr('type')) {
        el.on('focus', function() {
          el.qtip('disable', false);
          el.qtip('show');
        });
      }
    });
  });


  // enable fancy box
  // ??

})(jQuery);
